import React from 'react'

export default function Default() {
    return (
        <div>
            <h1>Hello from Default component</h1>
        </div>
    )
}
